<template>
  <footer class="footer">
    <div class="info-wrap content">
      <div>
        <p class="title">{{ config.appName }}相关</p>
        <a
          v-for="item in webInfo"
          :key="item.title"
          :href="item.url"
          target="_blank"
          >{{ item.title }}</a
        >
      </div>
      <div>
        <p class="title">协议相关</p>
        <a
          v-for="item in protocolList"
          :key="item.title"
          :href="item.url"
          target="_blank"
          >{{ item.title }}</a
        >
      </div>
      <div>
        <p class="title">联系方式</p>
        <p class="item-wrap">
          <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 27 32"
          >
            <path
              fill="rgba(255,255,255,0.6)"
              d="M22.857 21.456q0-0.196-0.036-0.286-0.054-0.143-0.688-0.527t-1.58-0.884l-0.946-0.518q-0.089-0.054-0.339-0.232t-0.446-0.268-0.375-0.089q-0.321 0-0.839 0.58t-1.018 1.17-0.786 0.589q-0.125 0-0.295-0.063t-0.277-0.116-0.304-0.17-0.25-0.152q-1.768-0.982-3.045-2.259t-2.259-3.045q-0.036-0.054-0.152-0.25t-0.17-0.304-0.116-0.277-0.063-0.295q0-0.232 0.366-0.598t0.804-0.688 0.804-0.705 0.366-0.652q0-0.179-0.089-0.375t-0.268-0.446-0.232-0.339q-0.054-0.107-0.268-0.509t-0.446-0.813-0.473-0.848-0.446-0.723-0.295-0.321-0.286-0.036q-0.857 0-1.804 0.393-0.821 0.375-1.429 1.688t-0.607 2.33q0 0.286 0.045 0.607t0.089 0.545 0.161 0.589 0.179 0.527 0.223 0.589 0.196 0.536q1.071 2.929 3.866 5.723t5.723 3.866q0.107 0.036 0.536 0.196t0.589 0.223 0.527 0.179 0.589 0.161 0.545 0.089 0.607 0.045q1.018 0 2.33-0.607t1.688-1.429q0.393-0.946 0.393-1.804zM27.429 7.581v17.143q0 2.125-1.509 3.634t-3.634 1.509h-17.143q-2.125 0-3.634-1.509t-1.509-3.634v-17.143q0-2.125 1.509-3.634t3.634-1.509h17.143q2.125 0 3.634 1.509t1.509 3.634z"
            /></svg
          ><a href="tel:400-628-2024">400-628-2024</a>
        </p>
        <p class="item-wrap">
          <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 37 32"
          >
            <path
              fill="rgba(255,255,255,0.6)"
              d="M16.891 14.309c0.384 0.301 0.873 0.483 1.406 0.483s1.022-0.182 1.411-0.487l-0.005 0.004 14.583-11.269c-1.681-1.87-4.108-3.040-6.808-3.040-0.017 0-0.035 0-0.052 0h-18.283c-0.015-0-0.032-0-0.049-0-2.7 0-5.127 1.171-6.801 3.032l-0.007 0.008zM22.491 17.897c-1.149 0.899-2.614 1.441-4.206 1.441s-3.057-0.542-4.221-1.453l0.015 0.011-13.851-10.743c-0.142 0.596-0.225 1.282-0.229 1.986v13.717c0 5.049 4.093 9.143 9.143 9.143v0h18.286c5.049 0 9.143-4.093 9.143-9.143v0-13.714c-0.003-0.707-0.087-1.392-0.241-2.050l0.012 0.062z"
            />
          </svg>
          <a href="mailto:service@moguoyunke.com"> service@moguoyunke.com</a>
        </p>
        <p class="title module-title">公司地址</p>
        <p class="item-wrap cont-text">
          北京市朝阳区来广营西路国创产业园6号楼E门5层5001
        </p>
      </div>
      <div class="official-account">
        <div class="official-account-item">
          <p class="title">{{ config.appName }}公众号</p>
          <img
            :src="
              cdnUrl + '/image/web_assets/qrcode_for_gh_d94af974800d_430_3.png'
            "
            alt=""
          />
        </div>
        <div class="official-account-item">
          <p class="title">{{ config.appName }}小红书</p>
          <img
            :src="cdnUrl + '/cdn/org/settled/xiao-hong-shu-qrcode.png'"
            alt=""
          />
        </div>
      </div>
    </div>
    <p class="filing-info">
      <span class="info-item"> Copyright &copy; {{ year }} {{ company }} </span>
      <a class="info-item" href="https://beian.miit.gov.cn/" target="_blank">{{
        beian
      }}</a>
      <a
        class="info-item"
        :href="
          'https://beian.mps.gov.cn/#/query/webSearch?code=' + config.recordCode
        "
        rel="noreferrer"
        target="_blank"
      >
        <img
          class="record-icon"
          src="@/assets/img/record-icon.png"
          alt=""
        />京公网安备 {{ config.recordCode }}号</a
      >
      <a
        class="info-item"
        target="_blank"
        href="https://tsm.miit.gov.cn/dxxzsp/ "
        >增值电信业务经营许可证：{{ config.licence }}</a
      >
    </p>
  </footer>
</template>

<script>
import config from "@saas/components/src/config/company.json";
export default {
  name: "CommonFooter",
  data() {
    return {
      year: new Date().getFullYear(),
      config: config,
      beian: config.beian,
      company: config.company,
      cdnUrl: process.env.VUE_APP_CDN_URL,
      webInfo: [
        {
          title: "关于我们",
          url: "/about",
        },
        {
          title: "联系我们",
          url: "/contact",
        },
        {
          title: "软件下载",
          url: "/download",
        },
      ],
      protocolList: [
        {
          title: "用户协议",
          url: "/service-agreement",
        },
        {
          title: "隐私协议",
          url: "https://cdn.moguocdn.com/cdn/static/privacy-policy.html",
        },
        {
          title: "机构服务协议",
          url: "/org-cooperate",
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.footer {
  background-color: #141818;
  width: 100%;
  text-align: center;
  color: #fff;
  .info-wrap .title.module-title {
    margin-bottom: 8px;
  }
  .cont-text {
    font-size: 14px;
    color: #adb2ad;
    line-height: 20px;
  }
  .item-wrap {
    display: flex;
    align-items: center;
    margin-bottom: 12px;
    a {
      margin-bottom: 0 !important;
      margin-left: 5px;
      margin-left: 5px;
    }
  }
  .content {
    background-color: #141818;
    color: #fff;
    min-height: auto;
  }
  .info-wrap {
    padding: 30px 20px 18px;
    display: flex;
    justify-content: space-between;
    & > div {
      display: flex;
      flex-direction: column;
      align-items: self-start;
      .title {
        font-weight: 500;
        font-size: 16px;
        color: #ffffff;
        line-height: 22px;
        margin-bottom: 12px;
      }
      .email,
      a {
        font-size: 14px;
        color: #adb2ad;
        line-height: 20px;
        margin-bottom: 12px;
      }
      img {
        width: 84px;
        height: 84px;
      }
    }
  }
  .filing-info {
    display: flex;
    justify-content: center;
    padding: 20px;
    border-top: 1px solid rgba($color: #fff, $alpha: 0.1);
    font-size: 12px;
    color: rgba($color: #fff, $alpha: 0.3);
    .info-item {
      display: flex;
      align-items: center;
      margin-right: 40px;
    }
    .info-item:last-child {
      margin-right: 0;
    }
    .record-icon {
      width: 14px;
      height: auto;
      margin-right: 4px;
    }
  }
  .official-account {
    display: flex;
    justify-content: space-between;
    flex-wrap: nowrap;
    flex-direction: row !important;
    gap: 0 20px;
    .official-account-item {
      display: flex;
      flex-direction: column;
    }
  }
}
@media (max-width: 767px) {
  .footer {
    overflow: hidden;
    width: 100%;
    min-width: auto;
    .info-wrap {
      padding: 0.4rem 0.27rem;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      & > div {
        display: flex;
        flex-direction: row;
        align-items: center;
        .title {
          line-height: 0.8rems;
          font-size: 0.37rem;
          font-weight: 600;
          color: hsla(0, 0%, 100%, 0.7);
          margin-right: 0.27rem;
        }
        a {
          color: #adb2ad;
          margin-right: 0.27rem;
          line-height: 0.8rem;
        }
        img {
          width: 1.33rem;
          height: 1.33rem;
        }
      }
    }
  }
  .filing-info {
    display: flex;
    flex-direction: column;
    align-items: center;
    border-top: 1px solid rgba($color: #fff, $alpha: 0.1);
    font-size: 12px;
    color: rgba($color: #fff, $alpha: 0.3);
    .info-item {
      display: flex;
      align-items: center;
      margin-right: 0 !important;
      padding: 3px 0;
      cursor: default !important;
    }
    .record-icon {
      width: 14px;
      height: auto;
      margin-right: 4px;
    }
  }
}
@media (max-width: 1200px) {
  .footer {
    .content {
      width: 100%;
    }
  }
}
</style>
